import { ChangeDetectionStrategy, Component } from "@angular/core";
import { DragDropDirective } from "app/core/ui";

/**
 * Header drag affordance that initiates host-side iframe dragging.
 */
@Component({
  selector: "fof-drag-handle",
  standalone: true,
  templateUrl: "./template.html",
  styleUrl: "./style.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [DragDropDirective],
})
export class DragHandleComponent {}
